import useReveal from "../../components/useReveal";
import { Ic, icons } from "../../components/Icons";

const channels = [
  {
    icon: icons.home,
    title: "Customer support",
    detail: "info@ateno.co",
    href: "mailto:info@ateno.co",
    desc: "Questions about your account, billing, or generated designs.",
  },
  {
    icon: icons.shield,
    title: "Security reports",
    detail: "info@ateno.co",
    href: "mailto:info@ateno.co",
    desc: "Responsible disclosure and security-related concerns.",
  },
  {
    icon: icons.lock,
    title: "Privacy requests",
    detail: "privacy@ateno.co",
    href: "mailto:privacy@ateno.co",
    desc: "Data access, deletion, and legal privacy requests.",
  },
  {
    icon: icons.zap,
    title: "Urgent assistance",
    detail: "+1 (302) 248-1852",
    href: "tel:+13022481852",
    desc: "Mon - Fri, 9 am - 6 pm ET for time-sensitive issues.",
  },
];

const faqs = [
  {
    q: "How quickly will I get a reply?",
    a: "Most requests receive a response within one business day. Critical account access and billing issues are prioritized.",
  },
  {
    q: "What should I include in my request?",
    a: "Include your account email, device type, and a concise description of the issue. Screenshots help us resolve things faster.",
  },
  {
    q: "Can I request account or data deletion?",
    a: (
      <>
        Yes. Email <a href="mailto:privacy@ateno.co">privacy@ateno.co</a> from the address on your account. We verify
        each request and process it promptly.
      </>
    ),
  },
  {
    q: "Do you offer support for developers?",
    a: "Yes. For API and integration questions, include endpoint details and request IDs so we can investigate quickly.",
  },
];

const checklistItems = [
  "Include your account email and a short summary of the issue.",
  "For technical problems, add steps to reproduce and screenshots when possible.",
];

export default function SupportPage() {
  useReveal();

  return (
    <div style={{ background: "var(--bg-primary)", paddingTop: 80 }}>
      <section className="section section-dark" style={{ paddingBottom: 32 }}>
        <div className="container-narrow" style={{ textAlign: "center" }}>
          <div className="reveal eyebrow">Support</div>
          <h1 className="reveal headline" style={{ marginBottom: 14 }}>
            We are here to help.
          </h1>
          <p className="reveal subhead" style={{ maxWidth: 520, margin: "0 auto" }}>
            Contact the Ateno team for product, billing, privacy, and technical support.
            Every request is reviewed by a real person.
          </p>
        </div>
      </section>

      <section className="section section-dark" style={{ paddingTop: 0, paddingBottom: 12 }}>
        <div className="container">
          <div className="grid-2" style={{ marginBottom: 12 }}>
            {channels.map((channel, i) => (
              <a
                key={channel.title}
                href={channel.href}
                className={`reveal reveal-d${i + 1} card-dark`}
                style={{
                  padding: "30px 26px",
                  textDecoration: "none",
                  display: "block",
                }}
              >
                <div className="feat-icon-wrap" style={{ marginBottom: 16 }}>
                  <Ic d={channel.icon} size={20} color="rgba(167,139,250,.88)" />
                </div>
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: "var(--text-primary)",
                    letterSpacing: "-.01em",
                    marginBottom: 4,
                  }}
                >
                  {channel.title}
                </div>
                <div
                  style={{
                    fontSize: 15,
                    fontWeight: 500,
                    color: "#818cf8",
                    marginBottom: 8,
                  }}
                >
                  {channel.detail}
                </div>
                <p style={{ fontSize: 13, color: "var(--text-muted)", lineHeight: 1.6 }}>
                  {channel.desc}
                </p>
              </a>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-dark" style={{ paddingTop: 24 }}>
        <div className="container">
          <div className="reveal support-checklist card-dark">
            <div className="support-checklist-inner">
              <div className="feat-icon-wrap">
                <Ic d={icons.layers} size={20} color="rgba(167,139,250,.88)" />
              </div>
              <div style={{ minWidth: 0, flex: 1 }}>
                <div className="eyebrow-muted" style={{ marginBottom: 12 }}>
                  Before you contact us
                </div>
                <h2 className="support-checklist-title">What to include</h2>
                <p className="support-checklist-lead">
                  Following these points helps us route and resolve your request faster.
                </p>
                <ul className="support-checklist-list">
                  {checklistItems.map((line) => (
                    <li key={line}>
                      <span className="support-checklist-check" aria-hidden="true">
                        <Ic d={icons.check} size={16} color="currentColor" sw={2} />
                      </span>
                      <span>{line}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="support-faq-section-label reveal">
            <div className="eyebrow-muted" style={{ marginBottom: 0 }}>
              Common questions
            </div>
          </div>

          <div className="grid-2 support-faq-grid">
            {faqs.map((faq, i) => (
              <div key={faq.q} className={`reveal reveal-d${(i % 4) + 1} card-dark support-faq-item`}>
                <h3 className="support-faq-q">{faq.q}</h3>
                <p className="support-faq-a">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
